import { ChecklistTargetType } from 'constants/checklists';

import { CHECKLISTS_ACTION_TYPE } from '../actions';

const initialState = ChecklistTargetType.LOAN;

const checklistsTargetReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHECKLISTS_ACTION_TYPE.SET_CHECKLIST_TARGET_TYPE:
      return payload || initialState;

    default:
      return state;
  }
};

export default checklistsTargetReducer;
